// extracted by mini-css-extract-plugin
module.exports = {"link":"menuItem-module--link--3G0Xq","item":"menuItem-module--item--1-Fr4","active":"menuItem-module--active--1Vs2X"};